import { connect } from 'react-redux';
import Enrichment from './components/Enrichment';
import {
  loadDnsRecords,
  loadARecordsDomainEnrichment,
  loadAAAARecordsDomainEnrichment,
  loadCNAMERecordsDomainEnrichment,
  loadMXRecordsDomainEnrichment,
  loadNSRecordsDomainEnrichment,
  loadSOARecordsDomainEnrichment,
  loadTXTRecordsDomainEnrichment,
  loadMergeAPIEnrichment,
  loadMergeAPINewEnrichment,
  loadUtilsParseIOC,
  loadMergeAPIDomainInfraTags,
  loadMergeAPIWhoisDetails,
  loadMergeAPIWhoisFallbackDetails,
  loadIpDensity,
  loadPTRLookup,
  exportExploreResultToCSV,
  exportExploreResultToJSON,
  exportSingleIOC,
} from '../../redux/actions/ioc';
import {
  createFileSource,
  createEmptySource,
  addIOCJson,
  loadSources,
  updateFileSource,
} from '../../redux/actions/source';
import {
  loadIPEditableFeeds,
  loadDomainEditableFeeds,
  loadURLEditableFeeds,
} from '../../redux/actions/feed';
import {
  loadUser,
  loadMySubscriptionPlan,
  loadMySubscriptionLimit,
} from '../../redux/actions/user';
import { resetEnrichment } from '../../redux/actions/ioc';
import { updateTag } from '../../redux/actions';
import { clearFilterProfile } from '../../redux/actions/filters';
import {
  checkEnrichmentFeedHasBlogs,
  resetEnrichmentFeedHasBlogsState,
} from '../../redux/actions/blog';

const mapStateToProps = (state) => ({
  user: state.user.user,
  sources: state.source.sources,
  newlyCreatedSource: state.source.newlyCreatedSource,
  enrichmentStatus: state.ioc.enrichmentStatus,
  newEnrichmentStatus: state.ioc.mergeAPINewEnrichmentStatus,
  scoreDetails: state.ioc.scoreDetails,
  dnsRecords: state.ioc.dnsRecords,
  dnsRecordsStatus: state.ioc.dnsRecordsStatus,

  ARecordsDomainEnrichmentData: state.ioc.ARecordsDomainEnrichmentData,
  ARecordsDomainEnrichmentStatus: state.ioc.ARecordsDomainEnrichmentStatus,
  AAAARecordsDomainEnrichmentData: state.ioc.AAAARecordsDomainEnrichmentData,
  AAAARecordsDomainEnrichmentStatus:
    state.ioc.AAAARecordsDomainEnrichmentStatus,
  CNAMERecordsDomainEnrichmentData: state.ioc.CNAMERecordsDomainEnrichmentData,
  CNAMERecordsDomainEnrichmentStatus:
    state.ioc.CNAMERecordsDomainEnrichmentStatus,
  MXRecordsDomainEnrichmentData: state.ioc.MXRecordsDomainEnrichmentData,
  MXRecordsDomainEnrichmentStatus: state.ioc.MXRecordsDomainEnrichmentStatus,
  NSRecordsDomainEnrichmentData: state.ioc.NSRecordsDomainEnrichmentData,
  NSRecordsDomainEnrichmentStatus: state.ioc.NSRecordsDomainEnrichmentStatus,
  SOARecordsDomainEnrichmentData: state.ioc.SOARecordsDomainEnrichmentData,
  SOARecordsDomainEnrichmentStatus: state.ioc.SOARecordsDomainEnrichmentStatus,
  TXTRecordsDomainEnrichmentData: state.ioc.TXTRecordsDomainEnrichmentData,
  TXTRecordsDomainEnrichmentStatus: state.ioc.TXTRecordsDomainEnrichmentStatus,

  mergeAPIEnrichment: state.ioc.mergeAPIEnrichment,
  mergeAPINewEnrichment: state.ioc.mergeAPINewEnrichment,
  parsedIOC: state.ioc.parsedIOC,
  parsedIOCStatus: state.ioc.parsedIOCStatus,
  exploreAPIwhoisDetails: state.ioc.exploreAPIwhoisDetails,
  exploreAPIwhoisFallbackDetails: state.ioc.exploreAPIwhoisFallbackDetails,
  whoisStatus: state.ioc.whoisStatus,
  whoisFallbackStatus: state.ioc.whoisFallbackStatus,
  domainInfraTags: state.ioc.domainInfraTags,
  infraTagStatus: state.ioc.infraTagStatus,
  ipDensityEnrichment: state.ioc.ipDensityEnrichment,
  ipDensityEnrichmentStatus: state.ioc.ipDensityEnrichmentStatus,
  ptrLookupEnrichment: state.ioc.ptrLookupEnrichment,
  ptrLookupEnrichmentStatus: state.ioc.ptrLookupEnrichmentStatus,

  IPEditableFeeds: state?.feed?.IPEditableFeeds,
  IPEditableFeedsStatus: state?.feed?.IPEditableFeedsStatus,
  DomainEditableFeeds: state?.feed?.DomainEditableFeeds,
  DomainEditableFeedsStatus: state?.feed?.DomainEditableFeedsStatus,
  URLEditableFeeds: state?.feed?.URLEditableFeeds,
  URLEditableFeedsStatus: state?.feed?.URLEditableFeedsStatus,
  mySubscriptionPlan: state.user.mySubscriptionPlan,
  mySubscriptionPlanStatus: state.user.mySubscriptionPlanStatus,
  mySubscriptionLimit: state.user.mySubscriptionLimit,
  mySubscriptionLimitStatus: state.user.mySubscriptionLimitStatus,

  enrichedIOCFeedBlogs: state.blog.enrichedIOCFeedBlogs,
  enrichedIOCFeedBlogsStatus: state.blog.enrichedIOCFeedBlogsStatus,

  availableFeeds: state.source?.sources,
  availableFeedsStatus: state.source?.loadSourcesStatus,
});

const mapDispatchToProps = {
  resetEnrichment,
  loadUser,
  loadDnsRecords,
  loadARecordsDomainEnrichment,
  loadAAAARecordsDomainEnrichment,
  loadCNAMERecordsDomainEnrichment,
  loadMXRecordsDomainEnrichment,
  loadNSRecordsDomainEnrichment,
  loadSOARecordsDomainEnrichment,
  loadTXTRecordsDomainEnrichment,
  loadMergeAPIEnrichment,
  loadMergeAPINewEnrichment,
  loadUtilsParseIOC,
  loadMergeAPIWhoisDetails,
  loadMergeAPIWhoisFallbackDetails,
  loadMergeAPIDomainInfraTags,
  loadIpDensity,
  loadPTRLookup,
  exportExploreResultToCSV,
  exportExploreResultToJSON,
  exportSingleIOC,
  createEmptySource,
  createFileSource,
  updateFileSource,
  addIOCJson,
  loadSources,
  loadIPEditableFeeds,
  loadDomainEditableFeeds,
  loadURLEditableFeeds,
  loadMySubscriptionPlan,
  loadMySubscriptionLimit,
  updateTag,
  clearFilterProfile,
  checkEnrichmentFeedHasBlogs,
  resetEnrichmentFeedHasBlogsState,
};

export default connect(mapStateToProps, mapDispatchToProps)(Enrichment);
